import React from "react";
import { Link, LinkProps } from "../../UI/Link";

type InlineLinkButtonProps = Omit<LinkProps, "component"> & {
  children: React.ReactNode;
};

export const InlineLinkButton: React.FC<InlineLinkButtonProps> = ({
  children,
  sx,
  ...rest
}) => (
  <Link
    component="button"
    type="button"
    sx={{
      display: "inline",
      p: 0,
      border: 0,
      background: "transparent",
      textDecoration: "none",
      fontWeight: 700,
      cursor: "pointer",
      fontSize: "inherit",
      lineHeight: "inherit",
      verticalAlign: "baseline",
      "&:hover": {
        textDecoration: "underline",
      },
      ...sx,
    }}
    {...rest}
  >
    {children}
  </Link>
);
